export default {
  // Document titles
  'quotation.preliminary': '1차 견적서',
  'quotation.finalOffer': '2차 확정 견적서',

  // Meta
  'quotation.quoteNumber': '견적 번호',
  'quotation.offerNumber': '확정 견적 번호',
  'quotation.status': '상태',
  'quotation.createdDate': '작성일',
  'quotation.quoteType': '견적 유형',
  'quotation.quoteCurrency': '견적 통화',
  'quotation.issuedDate': '발행일',
  'quotation.validUntil': '유효기간',
  'quotation.reference': '관련 1차 견적',

  // Sections
  'quotation.buyerInfo': '구매자 정보',
  'quotation.products': '제품',
  'quotation.finishing': '후가공 / 장식',
  'quotation.printing': '인쇄',
  'quotation.specialRequirements': '특별 요청사항',
  'quotation.pricingSummary': '가격 요약',
  'quotation.commercialCharges': '상업적 비용',
  'quotation.commercialTerms': '상업 조건',

  // Pricing rows
  'quotation.productSubtotal': '제품 소계',
  'quotation.finishingSubtotal': '후가공 소계',
  'quotation.preliminaryTotal': '1차 견적 합계',
  'quotation.preliminaryQuoteTotal': '1차 견적 합계',
  'quotation.finalTotal': '최종 합계',

  // Commercial charges
  'quotation.freight': '운임',
  'quotation.insurance': '보험',
  'quotation.customsClearance': '통관',
  'quotation.duty': '관세',
  'quotation.tax': '세금 / 부가세',
  'quotation.manualAdjustment': '수동 조정',
  'quotation.discount': '할인',

  // Commercial terms
  'quotation.paymentTerms': '결제 조건',
  'quotation.leadTime': '리드타임',
  'quotation.deliveryTerms': '납품 조건',
  'quotation.incoterms': '인코텀즈',
  'quotation.commercialNotes': '상업 비고',

  // Product detail fields
  'quotation.quantity': '수량',
  'quotation.unitPrice': '단가',
  'quotation.amount': '금액',
  'quotation.sku': 'SKU',
  'quotation.material': '재질',
  'quotation.capacity': '용량',
  'quotation.specification': '규격',

  // Buyer fields
  'quotation.companyName': '회사명',
  'quotation.contactPerson': '담당자',
  'quotation.country': '국가',
  'quotation.address': '주소',
  'quotation.email': '이메일',
  'quotation.phone': '전화',

  // PDF
  'quotation.pdfView': 'PDF 보기',
  'quotation.pdfDownload': 'PDF 다운로드',
  'quotation.pdfGenerating': 'PDF 생성 중...',
  'quotation.pdfError': 'PDF를 생성하지 못했습니다. 다시 시도해주세요.',
  'quotation.pdfClose': '닫기',
  'quotation.pdfOpenNewTab': '새 탭에서 열기',
  'quotation.pdfLoading': 'PDF 불러오는 중...',
  'quotation.pdfLoadError': 'PDF를 불러올 수 없습니다.',
  'quotation.pdfLoadErrorHint': '잠시 후 다시 시도해주세요.',
  'quotation.pdfRetry': '다시 시도',
  'quotation.pdfFitWidth': '너비 맞춤',
  'quotation.pdfZoomIn': '확대',
  'quotation.pdfZoomOut': '축소',

  // Quote type
  'quotation.type.production': '양산',
  'quotation.type.sample': '샘플',
};